import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer';

const Layout = ({ children }) => {
  return (
    <div id="page" className="hfeed site">
      <Header />
      <main className="site-main" id="main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
